import { checklistAuthorizedTo, meta } from '@/services/api';
import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/DateFromUnixTime';

export const checklistCodec = t.type({
  id: t.number,
  title: t.string,
  lastConductedAt: t.union([t.null, DateFromUnixTime]),
  authorizedTo: checklistAuthorizedTo,
});

export const checklistsResponseCodec = t.type({
  data: t.array(checklistCodec),
  meta,
});
